import { Icon } from '~/components/atomic';
import * as S from './MypageList.styled';

export type MypageList = {
  id: string;
  menuName: string;
  rightInfo: string | 'arrow';
  onClick?: () => void;
  red?: boolean;
};

interface MypageListProps {
  arr: MypageList[];
  mode?: 'transparent' | 'default' | 'light';
}

export default function MypageList({ arr, mode = 'default' }: MypageListProps) {
  return (
    <S.MenuBox mode={mode}>
      {arr.map((menu) => {
        const { id, menuName, onClick, rightInfo, red } = menu;
        return (
          <S.Menu key={id} onClick={onClick}>
            <S.MenuInner>
              <S.Name mode={mode} red={red ? red : false}>
                {menuName}
              </S.Name>
              {rightInfo === 'arrow' ? (
                <div>
                  <Icon
                    color='content_light_1'
                    size={24}
                    iconName='ArrowRight'
                  />
                </div>
              ) : (
                <S.RightInfo>{rightInfo}</S.RightInfo>
              )}
            </S.MenuInner>
          </S.Menu>
        );
      })}
    </S.MenuBox>
  );
}
